"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInlineTextFieldFactory = void 0;
const react_1 = __importStar(require("react"));
const form_text_field_1 = require("../../../composite/form/fields/form-text-field");
const inline_table_context_1 = require("../inline-table-context");
function useInlineTextFieldFactory(props) {
    return react_1.useMemo(() => function InlineCell(tableFieldProps) {
        return (react_1.default.createElement(InlineTextFieldCell, { inlineProps: props, tableFieldProps: tableFieldProps }));
    }, [props]);
}
exports.useInlineTextFieldFactory = useInlineTextFieldFactory;
function InlineTextFieldCell({ inlineProps, tableFieldProps, }) {
    const { disabled: tableDisabled } = react_1.useContext(inline_table_context_1.InlineTableFieldContext);
    const { isSubkey = true, collectionDatakey, disabled, type, inputProps, } = inlineProps;
    const { index, column } = tableFieldProps;
    return (react_1.default.createElement(form_text_field_1.FormTextField, { name: isSubkey
            ? `${collectionDatakey}[${index}].${column.datakey}`
            : `${collectionDatakey}[${index}]`, labelOptions: { hide: true }, layoutOptions: { noUnderline: true }, disabled: tableDisabled ||
            (typeof disabled === 'function' ? disabled(index) : disabled), type: type, inputProps: inputProps }));
}
//# sourceMappingURL=inline-text-field-cell.js.map